module.exports = __webpack_public_path__ + "img/defaultProduct.29e298d9.jpg";